/**
 * Text used in the fees, waivers, and exemptions page.
 */
export const FeesWaiversExemptionsHelperMessages = {
    applicationFeeExemption:
        'Is the Applicant exempt from FCC application fees?',
    regulatoryFeeExemption: 'Is the applicant exempt from FCC regulatory fees?',
    waiverRequest:
        "Does this application include a request for a Waiver of the Commission's Rule(s)?",
    grandfatheredPrivileges:
        'Are the frequencies or parameters requested in this filing covered by grandfathered privileges, previously approved by waiver, or functionality integrated with an existing station?',
};
